import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_PROMOTION,
  UPDATE_PROMOTION_FAILURE,
  UPDATE_PROMOTION_SUCCESS,
  UpdatePromotionActionType
} from 'src/redux/promotionsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateMobileListingFlow(action: UpdatePromotionActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const {
      motorbikeId,
      promotionId,
      highlights,
      photoIds,
      coverPhotoId,
      highlight_1: _highlight1,
      highlight_2: _highlight2,
      highlight_3: _highlight3,
      ...listing
    } = action.payload
    void _highlight1
    void _highlight2
    void _highlight3
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${motorbikeId}/mobile_listings/${promotionId}`,
      api: 'market-api',
      method: PUT,
      params: {
        mobile_listing: {
          ...listing,
          highlights,
          ...(photoIds === null ? {} : { photo_ids: photoIds, cover_photo_id: coverPhotoId })
        }
      }
    })
    yield put(UPDATE_PROMOTION_SUCCESS())
    yield put(SHOW_TOAST({ message: t('my_vehicles.toast_promotion_updated') }))
  } catch (error) {
    if (error instanceof Error) {
      yield put(UPDATE_PROMOTION_FAILURE(error.message))
    } else {
      yield put(UPDATE_PROMOTION_FAILURE())
    }
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateMobileListingSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_PROMOTION, UpdateMobileListingFlow)
}
